<template>
  <!-- 合规详情主容器 -->
  <div class="common_group">
    <!-- 标题栏，包含图标、文本和操作按钮组 -->
    <div class="title">
      <img src="@/assets/images/fileIcon.png">
      <!-- 活动资料附件 -->
      <span>{{ $t('file.hdzlfj') }}</span>{{ $t('notic.hgtsinfo') }}
      <div class="buttonBar">
        <!-- 提交按钮 -->
        <el-button v-if="permissionMap.submit" type="primary" @click="handleSubmit"> {{ $t('btn.Submit') }}</el-button>
        <!-- 召回按钮 -->
        <el-button v-if="editEchoData.allowRecallEditCompliance" type="primary" @click="handleRecall"> {{ $t('btn.zh') }}</el-button>
        <!-- 同意按钮 -->
        <el-button
          v-if="editEchoData.allowApproveCompliance"
          type="primary"
          @click="agreeRejectBtn($t('btn.Agree'))"
        >
          {{ $t('btn.Agree') }}
        </el-button>
        <!-- 驳回按钮 -->
        <el-button v-if="editEchoData.allowApproveCompliance" plain @click="agreeRejectBtn($t('btn.Rejected'))">{{ $t('btn.Rejected') }}</el-button>
      </div>
    </div>
    <!-- 合规资料申请状态 -->
    <div class="imitate">
      <div class="imitate_item imitate_title">
        <div>
          {{ $t('approvalCenter.TheApplicant') }}
        </div>
        <div>
          {{ $t('general.Status') }}
        </div>
      </div>
      <div class="imitate_item imitate_content">
        <div>
          {{ editEchoData.complianceProcessDetailVO.applyUserName }}
        </div>
        <div>
          <span v-if="isNotInitiated">{{ editEchoData.complianceProcessDetailVO.approveStatus }}</span>
          <el-button v-else class="status-but" type="text" @click="viewProcess">{{ editEchoData.complianceProcessDetailVO.approveStatus }}</el-button>
        </div>
      </div>
    </div>
    <!-- 合规信息表格组件 -->
    <commonTable v-if="permissionMap.examine" ref="complianceTable" />
    <!-- 合规文档组件 -->
    <complianceDocuments ref="complianceDocuments" v-if="permissionMap.uploader" :edit-echo-data="editEchoData" />
    <!-- 同意/驳回对话框组件 -->
    <agreeDialog
      ref="agreeDialog"
      @agreeSubHandle="agreeSubHandle"
    />
    <!-- 审批流程对话框组件 -->
    <approvalProcessDialog
      ref="approvalProcessDialog"
    />
  </div>
</template>

<script>
// 导入同意/驳回对话框组件
import agreeDialog from './agreeDialog';
// 导入通用表格组件
import commonTable from 'components/commonTable';
// 导入审批流程对话框组件
import approvalProcessDialog from './approvalProcessDialog.vue';
// 导入合规文档组件
import complianceDocuments from './complianceDocuments.vue';
// 导入混入
import { complianceMixin } from './complianceMixin.js';

export default {
  // 组件名称
  name: 'DetailsCompliance',
  props: {
    editEchoData: {
      type: Object,
      default: () => {}
    }
  },
  // 注册子组件
  components: {
    commonTable,
    complianceDocuments,
    agreeDialog,
    approvalProcessDialog
  },
  // 注册混入
  mixins: [complianceMixin],
  computed: {
    isNotInitiated   () {
      const statusList = ['Not initiated', '未发起'];
      return statusList.includes(this.editEchoData.complianceProcessDetailVO.approveStatus);
    }
  }
};
</script>

<style scoped lang="scss">
/* 文件列表样式 */
.table_file {
    >img { /* 文件图标样式 */
      vertical-align: middle;
    }
    >span { /* 文件名样式 */
      margin-left: 10px;
      display: inline-block;
      vertical-align: middle;
    }
}
.imitate {
  border: 1px solid #e2e4e9;
  border-bottom: none;
  .imitate_item {
    display: flex;
    height: 48px;
    line-height: 48px;
    background-color: #fcfdfc;
    padding: 0 10px;
    font-size: 12px;
    color: #5b646e;
    div {
      padding: 0 10px;
      width: 100px;
      .status-but {
        min-width: auto;
        padding: 0 !important;
        font-size: 12px!important;
      }
    }
  }
  .imitate_title {
    height: 52px;
    line-height: 52px;
    border-bottom: 1px solid #e2e4e9;
    background-color: #f6f7f7;
  }
  .imitate_content:hover {
    background-color: #eaf5f4;
  }
}
</style>
